import React from 'react';
import { AprMark } from './BrandMarks';

/**
 * Last line of defense: rendered by the Sentry ErrorBoundary when a render
 * error escapes. The error itself has already been reported.
 */
function ErrorFallback({ onReset, admin = false }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      background: 'var(--brand-bg, #000)', color: 'var(--brand-fg, #fff)',
      fontFamily: 'var(--font-sans, Inter, system-ui, sans-serif)',
    }}>
      <div style={{ maxWidth: 440, lineHeight: 1.55 }}>
        <AprMark height={32} />
        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '20px 0 8px' }}>Something went wrong on our side</h1>
        <p style={{ color: 'var(--brand-fg-read, #E6E6E6)', margin: '0 0 20px' }}>
          {admin
            ? 'The portal hit an error. It has been reported; reloading usually clears it.'
            : "Rob's still here. The page just stumbled. It has been reported; reloading usually clears it."}
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <button
            type="button"
            className="apr-btn"
            onClick={() => { if (onReset) onReset(); window.location.reload(); }}
          >
            Reload
          </button>
          {!admin && (
            <a href="/crisis-help" className="apr-btn apr-btn--quiet">
              Need someone now? Crisis resources
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
